<div class="expression-editor">
  <textarea
    #ta
    class="expression-input"
    [rows]="rows()"
    [value]="value()"
    [attr.placeholder]="placeholder()"
    (input)="onInput($event)"
    spellcheck="false"
  ></textarea>

  @if (groups().length > 0) {
    <aside class="expression-tokens">
      <span class="expression-tokens-label">Insert</span>
      <div class="expression-token-groups">
        @for (g of groups(); track g.label) {
          <details class="expression-token-group">
            <summary>{{ g.label }}</summary>
            <div class="expression-token-chips">
              @for (t of g.tokens; track t) {
                <button type="button" class="token" (click)="insertToken(t)">
                  {{ t }}
                </button>
              }
            </div>
          </details>
        }
      </div>
    </aside>
  } @else {
    <p class="expression-empty">
      No entity catalog provided — type expressions free-form. Syntax:
      <code>Entity.Property == EnumType.Value</code>.
    </p>
  }
</div>
